import React, { Component } from 'react';
//import './ScreenInvaders.css';
//import Partners from '../../backgrounds/Partners';
import './ScreenServices.css';

class BlockServices extends Component
{
  render()
  {
      return (
        <div className="index-block bg-black" id="BlockServices">
          <div className="container">
            <div className="row main">
              <div>
                <div className="col-xs-12 col-md-2"></div>
                <div className="col-xs-12 col-md-8">
                  <h3>Services</h3>
                  <hr />
                </div>
                <div className="col-xs-12 col-md-2"></div>
              </div>
            </div>

            <div className="row main">
              <div className="service col-md-4">
                <div className="box">
                  <i className="fa fa-code" aria-hidden="true"></i><br />
                  <h2>WEB</h2>
                </div>
                Websites from Α to Ω. Frontend, backend, SEO, performance optimization.
              </div>
              <div className="service col-md-4">
                <div className="box ">
                  <i className="fa fa-gamepad" aria-hidden="true"></i><br />
                  <h2>Apps & Games</h2>
                </div>
                From small scale christmas or birthday browser games to full featured online educational games.
              </div>
              <div className="service col-md-4">
                <div className="box">
                  <img src="/assets/icons/headset-blue.svg" alt="Augmented reality, virtual reality, mixed reality" className="fa-img visible-md-inline visible-lg-inline" />
                  <img src="/assets/icons/headset-white.svg" alt="Augmented reality, virtual reality, mixed reality" className="fa-img visible-xs-inline visible-sm-inline" /><br />
                  <h2>AR/VR</h2>
                </div>
                Augmented, virtual and mixed reality apps to enhance the user experience with interactive environment.
              </div>
            </div>
          </div>
        </div>
      )
  }
}

export default BlockServices;



// WEBPACK FOOTER //
// ./src/screens/screenServices/BlockServices.js